import { parseLogSearch, type LogFilter } from './logSearch';

/**
 * The event report's filter, as it lives in the URL.
 *
 * The same shape and the same parse as the audit report's — see `logSearch.ts`, which is where
 * both of them get it, and which is written to stay out of the eager bundle on both their behalfs.
 *
 * STILL AN EAGER MODULE: `validateSearch` runs during routing, so anything imported here is on
 * every page of the app. The event vocabulary is 2 KB and belongs in `eventFilter.ts`, which is
 * reached only from this report's own chunk.
 */
export type EventFilter = LogFilter;

export const parseEventSearch: (search: Record<string, unknown>) => EventFilter = parseLogSearch;
